type Answers = Record<string, unknown>;

/**
 * Transitive closure of forced answers from a template's `_requires` map.
 *
 * If a selected (on) toggle requires others, those are "forced" on — and since
 * a forced toggle is itself on, it propagates to ITS requirements too
 * (postgres → backend → docker). Returns a map of `forcedKey → requiredByKey`
 * so the wizard can lock the checkbox and show "Required by <requiredByKey>".
 *
 * A toggle is forced even if the user also turned it on, so it stays locked
 * (you can't uncheck `backend` while `postgres` is selected).
 */
export function computeForced(
  answers: Answers,
  requires: Record<string, string[]>,
): Record<string, string> {
  const forced: Record<string, string> = {};
  const isOn = (key: string): boolean => answers[key] === true || key in forced;

  let changed = true;
  while (changed) {
    changed = false;
    for (const [key, deps] of Object.entries(requires)) {
      if (!isOn(key)) continue;
      for (const dep of deps) {
        if (!(dep in forced)) {
          forced[dep] = key;
          changed = true;
        }
      }
    }
  }
  return forced;
}
